module.exports = __webpack_public_path__ + "img/4.081d6987.png";